export class Encuestas {
    idSubmit?: number;
    idPerfil!: number;
    idCompetencia!: number;
    value!: number;
    date!: string;
}
